export function getElementTopYPosition(element) {
  return element.getBoundingClientRect().top + document.documentElement.scrollTop;
}
